@if (control) {
  <astral-toggle
    [control]="control"
    [helpText]="helpText"
    [showCaption]="showCaption"
    (valueChange)="valueChange.emit($event)"
  ></astral-toggle>
}
@if (!control) {
  <div class="d-inline-block position-relative">
    <label class="toogle">
      <input type="checkbox" [checked]="dataContext" readonly="readonly" (change)="onToggleChange($event)" />
      <span class="slider" [class.toggle-disabled]="isDisabled"></span>
    </label>
  </div>
}
